import { useStyles } from '@team-griffin/stylr';
import { useBreakpoints } from '@ux/responsive';
import { useTheme, Colorway } from '@uds/theme-utils';
import { headingXxl, headingXl, headingL, headingM, headingS, headingXs, headingXxs } from '@ux/type-size';
import { getTitleColor } from 'presentation/utils/colorway';

// cascading font sizes per heading level and breakpoint
const levelFunctions = [
  // xs
  [
    headingXl, // h1
    headingL, // h2
    headingM, // h3
    headingS, // h4
    headingXs, // h5
    headingXxs, // h6
  ],
  // sm
  [headingXxl, headingXl, headingL, headingM, headingS, headingXs],
  // lg
  [headingXxl, headingXxl, headingXl, headingL, headingM, headingS],
];

export default ({ level, colorway }: { level: number; colorway: Colorway }) => {
  const { theme } = useTheme();
  const { typography } = theme;
  const { isMinSm, isMinLg } = useBreakpoints();
  const levelFunction = (index: number) => levelFunctions[index][level - 1]();

  return useStyles(
    {
      default: {
        root: {
          color: getTitleColor(theme, colorway),
          fontFamily: typography.display,
          fontWeight: 'normal',
          ...levelFunction(0),
        },
      },

      isMinSm: {
        root: {
          ...levelFunction(1),
        },
      },

      isMinLg: {
        root: {
          ...levelFunction(2),
        },
      },
    },
    [{ isMinSm }, { isMinLg }],
  );
};
